export default "__VITE_ASSET__CHlnLI$y__"